import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { ArrowLeft, Shield, Database, Mail, Trash2, UserCheck } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 font-mono text-sm text-zinc-500 hover:text-primary transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          VOLVER
        </Link>

        <div className="bg-[#111] border border-zinc-800 p-8">
          <div className="flex items-center gap-3 mb-8">
            <Shield className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-black tracking-tighter">
              POLÍTICA DE <span className="text-primary">PRIVACIDAD</span>
            </h1>
          </div>

          <p className="text-zinc-400 mb-8 font-mono text-sm">
            Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          {/* Responsable */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <UserCheck className="w-5 h-5 text-primary" />
              1. RESPONSABLE DEL TRATAMIENTO
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p><strong className="text-zinc-300">Responsable:</strong> ROCKMAPS</p>
              <p><strong className="text-zinc-300">Email de contacto:</strong> privacidad@rockmaps.es</p>
              <p><strong className="text-zinc-300">Finalidad:</strong> Gestión de la plataforma de eventos y locales de música rock.</p>
            </div>
          </section>

          {/* Datos recopilados */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Database className="w-5 h-5 text-primary" />
              2. DATOS QUE RECOPILAMOS
            </h2>
            <div className="text-zinc-400 space-y-4">
              <p>Recopilamos los siguientes datos personales:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong className="text-zinc-300">Datos de registro:</strong> Nombre, email, contraseña (encriptada)</li>
                <li><strong className="text-zinc-300">Datos de perfil de bar:</strong> Nombre del local, dirección, teléfono, horarios, descripción</li>
                <li><strong className="text-zinc-300">Datos de uso:</strong> Eventos guardados, preferencias</li>
                <li><strong className="text-zinc-300">Datos técnicos:</strong> Dirección IP, tipo de navegador (para seguridad)</li>
              </ul>
            </div>
          </section>

          {/* Base legal */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">3. BASE LEGAL DEL TRATAMIENTO</h2>
            <div className="text-zinc-400 space-y-2">
              <p>El tratamiento de tus datos se basa en:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong className="text-zinc-300">Consentimiento:</strong> Al registrarte y aceptar esta política</li>
                <li><strong className="text-zinc-300">Ejecución contractual:</strong> Para prestarte el servicio de la plataforma</li>
                <li><strong className="text-zinc-300">Interés legítimo:</strong> Para mejorar nuestros servicios y seguridad</li>
              </ul>
            </div>
          </section>

          {/* Derechos RGPD */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Shield className="w-5 h-5 text-primary" />
              4. TUS DERECHOS (RGPD)
            </h2>
            <div className="text-zinc-400 space-y-4">
              <p>Conforme al Reglamento General de Protección de Datos (RGPD), tienes derecho a:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong className="text-zinc-300">Acceso:</strong> Solicitar una copia de tus datos personales</li>
                <li><strong className="text-zinc-300">Rectificación:</strong> Corregir datos inexactos o incompletos</li>
                <li><strong className="text-zinc-300">Supresión:</strong> Solicitar la eliminación de tus datos ("derecho al olvido")</li>
                <li><strong className="text-zinc-300">Limitación:</strong> Restringir el tratamiento de tus datos</li>
                <li><strong className="text-zinc-300">Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
                <li><strong className="text-zinc-300">Oposición:</strong> Oponerte al tratamiento de tus datos</li>
              </ul>
              <p className="mt-4">
                Para ejercer estos derechos, contacta con nosotros en{" "}
                <a href="mailto:privacidad@rockmaps.es" className="text-primary hover:underline">
                  privacidad@rockmaps.es
                </a>
              </p>
            </div>
          </section>

          {/* Eliminación de datos */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Trash2 className="w-5 h-5 text-primary" />
              5. ELIMINACIÓN DE CUENTA Y DATOS
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Puedes solicitar la eliminación completa de tu cuenta y todos los datos asociados 
                enviando un email a{" "}
                <a href="mailto:privacidad@rockmaps.es" className="text-primary hover:underline">
                  privacidad@rockmaps.es
                </a>
              </p>
              <p>
                Si eres propietario de un bar, la eliminación incluirá todos los eventos publicados.
              </p>
              <p>
                Procesaremos tu solicitud en un plazo máximo de 30 días.
              </p>
            </div>
          </section>

          {/* Comunicaciones */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Mail className="w-5 h-5 text-primary" />
              6. COMUNICACIONES
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Solo te enviaremos comunicaciones relacionadas con el servicio (recuperación de 
                contraseña, notificaciones importantes). No compartimos tus datos con terceros 
                para fines publicitarios.
              </p>
            </div>
          </section>

          {/* Seguridad */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">7. SEGURIDAD DE LOS DATOS</h2>
            <div className="text-zinc-400 space-y-2">
              <p>Implementamos medidas de seguridad técnicas y organizativas:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Encriptación de contraseñas con algoritmos seguros</li>
                <li>Conexiones HTTPS cifradas</li>
                <li>Acceso restringido a datos personales</li>
                <li>Copias de seguridad periódicas</li>
              </ul>
            </div>
          </section>

          {/* Cookies */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">8. COOKIES</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Utilizamos cookies técnicas esenciales para el funcionamiento de la plataforma 
                (sesión de usuario, preferencias). No utilizamos cookies de seguimiento ni 
                publicitarias de terceros.
              </p>
            </div>
          </section>

          {/* Contacto */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">9. CONTACTO</h2>
            <div className="text-zinc-400">
              <p>
                Para cualquier consulta sobre esta política de privacidad o el tratamiento 
                de tus datos, puedes contactarnos en:{" "}
                <a href="mailto:privacidad@rockmaps.es" className="text-primary hover:underline">
                  privacidad@rockmaps.es
                </a>
              </p>
            </div>
          </section>

          {/* Autoridad de control */}
          <section>
            <h2 className="text-xl font-bold text-white mb-4">10. AUTORIDAD DE CONTROL</h2>
            <div className="text-zinc-400">
              <p>
                Si consideras que el tratamiento de tus datos no es adecuado, puedes presentar 
                una reclamación ante la Agencia Española de Protección de Datos (AEPD):{" "}
                <a 
                  href="https://www.aepd.es" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-primary hover:underline"
                >
                  www.aepd.es
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
